const meta = {
  kubernetes: 'Kubernetes (metrics)',
  tracing: 'Kubernetes (traces)',
  standalone: 'Standalone',
  upgrade: 'Upgrade',
};

export default meta;
